import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-email-verified-success',
  templateUrl: './email-verified-success.component.html',
  styleUrls: ['./email-verified-success.component.scss']
})
export class EmailVerifiedSuccessComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  login(){
    this.router.navigateByUrl('/auth');
  }

}
